import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmModalComponent implements OnInit {
  constructor(private activeModal: NgbActiveModal) {}

  @Input() displayText!: string;
  // Optional title — falls back to "Confirm" / "Confirm action" so the
  // modal always has a proper header instead of a bare question floating
  // in the body.
  @Input() title: string = 'Confirm';
  @Input() hideCancelButton: boolean = false;
  @Input() cancelButtonText: string = 'Cancel';
  @Input() continueButtonText: string = 'Continue';
  // Set to 'danger' when the confirm button represents a destructive
  // action (deactivate, archive, delete) — paints the primary button red
  // so users have a clear visual cue.
  @Input() confirmTone: 'primary' | 'danger' = 'primary';
  /**
   * A consequence the caller wants read separately from `displayText` — shown
   * in its own alert so it is not skimmed past as part of the paragraph.
   */
  @Input() consequenceText?: string;
  /**
   * When set, Continue stays disabled until the box is ticked. For a decision
   * that reaches someone outside VIVE, where "I clicked through it" is not the
   * same as "the client knows".
   */
  @Input() acknowledgementText?: string;

  public acknowledged = false;

  public get canContinue(): boolean {
    return !this.acknowledgementText || this.acknowledged;
  }

  continue() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.close(false);
  }

  ngOnInit(): void {}
}
